// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error_msg[data-v-446a9364]{color:#fa2e69;font-size:16px;margin-bottom:4px}", ""]);
// Exports
module.exports = exports;
